import { Link } from "react-router-dom";
import { Clock, ListChecks, Trophy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, EmptyState, InactiveNotice } from "@/components/dash/Common";
import { FullLoader } from "@/components/ProtectedRoute";
import { useApi } from "@/hooks/useApi";
import { useAuth } from "@/context/AuthContext";
import { fmtDateTime, isPackageActive } from "@/lib/format";

function ExamCard({ e }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-6" data-testid={`exam-card-${e.id}`}>
      <div className="flex flex-wrap justify-between gap-4">
        <div>
          <p className="font-display text-lg font-semibold text-slate-900">{e.title}</p>
          {e.description && <p className="text-sm text-slate-600 mt-1">{e.description}</p>}
          <div className="flex gap-4 text-xs text-slate-500 mt-3">
            <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{e.duration_min} menit</span>
            <span className="flex items-center gap-1"><ListChecks className="h-3.5 w-3.5" />{e.question_count} soal</span>
            {e.best_score != null && <span className="flex items-center gap-1 text-slate-900 font-semibold"><Trophy className="h-3.5 w-3.5 text-amber-500" />Terbaik {e.best_score}</span>}
          </div>
        </div>
        <Button asChild className="bg-amber-500 text-slate-900 hover:bg-amber-400" disabled={!e.question_count} data-testid={`start-exam-${e.id}`}>
          <Link to={`/siswa/ujian/${e.id}`}>{e.attempts.length ? "Kerjakan Ulang" : "Mulai Ujian"}</Link>
        </Button>
      </div>
      {e.attempts.length > 0 && (
        <div className="mt-5 border-t border-slate-100 pt-4 space-y-2">
          <p className="text-xs uppercase tracking-wider text-slate-500">Riwayat nilai</p>
          {e.attempts.map((a) => (
            <div key={a.id} className="flex justify-between items-center text-sm">
              <span className="text-slate-600">{fmtDateTime(a.submitted_at)}</span>
              <span className="flex items-center gap-3"><span className="font-mono font-bold">{a.score}</span><Link to={`/siswa/hasil/${a.id}`} className="text-amber-600 hover:underline text-xs" data-testid={`review-attempt-${a.id}`}>Pembahasan</Link></span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function StudentExams() {
  const { user } = useAuth();
  const { data, loading } = useApi("/student/exams");
  if (loading) return <FullLoader />;
  return (
    <div data-testid="student-exams-page">
      <PageHeader eyebrow="Ujian" title="Ujian, nilai & pembahasan" description="Ujian berbasis komputer (CBT) dengan timer. Nilai keluar otomatis setelah submit." />
      {!isPackageActive(user) ? <InactiveNotice /> : (
        <div className="space-y-4">{data?.length ? data.map((e) => <ExamCard key={e.id} e={e} />) : <EmptyState text="Belum ada ujian untuk paket Anda." />}</div>
      )}
    </div>
  );
}
